import { Heart } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="py-12 bg-card border-t">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="space-y-4">
            <h3 className="font-bold text-lg">Second Chance Connect</h3>
            <p className="text-sm text-muted-foreground">
              Breaking down barriers to employment for people with criminal records across the UK.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-3">For Job Seekers</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/ai-resume-builder" className="hover:text-foreground">Build Your Resume</a></li>
              <li><a href="/job-search" className="hover:text-foreground">Find Jobs</a></li>
              <li><a href="/interview-prep" className="hover:text-foreground">Interview Prep</a></li>
              <li>Success Stories</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3">For Employers</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/employer-auth" className="hover:text-foreground">Post Jobs</a></li>
              <li><a href="/employer-auth" className="hover:text-foreground">Find Talent</a></li>
              <li><a href="/legal-guidance" className="hover:text-foreground">Legal Guidance</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3">Resources</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/privacy" className="hover:text-foreground">Privacy Policy</a></li>
              <li><a href="/cookies" className="hover:text-foreground">Cookie Policy</a></li>
              <li><a href="/subject-rights" className="hover:text-foreground">Your Data Rights</a></li>
              <li><a href="/about" className="hover:text-foreground">About Us</a></li>
              <li><a href="/terms" className="hover:text-foreground">Terms of Service</a></li>
              <li><a href="/contact" className="hover:text-foreground">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t text-center">
          <p className="text-sm text-muted-foreground flex items-center justify-center gap-2">
            Made with <Heart className="w-4 h-4 text-accent fill-accent" /> everyone deserve second chance in life
          </p>
          <p className="text-xs text-muted-foreground mt-2">
            © 2025 Second Chance Connect. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
